import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginModal from "./ModalComponents/LoginModal";
import SignUpModal from "./ModalComponents/SignUpModal";
import MobileNavModal from "./ModalComponents/MobileNavModal";
import "../css/PublicNav.css";
import "../css/ContactUs.css";
import HamburgerIcon from "./icons/HamburgerIcon";

const PublicNav = () => {
  const [isGetStartedOpen, setIsGetStartedOpen] = useState(false);
  const [isLoginView, setIsLoginView] = useState(true);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navigate = useNavigate();

  // Functions to open and close modals
  const openGetStarted = useCallback(() => setIsGetStartedOpen(true), []);
  const closeGetStarted = useCallback(() => setIsGetStartedOpen(false), []);
  const openOurTeam = useCallback(() => navigate("/our-team"), [navigate]);
  const openPricing = useCallback(() => navigate("/pricing"), [navigate]);
  const openContactUs = useCallback(() => navigate("/contact-us"), [navigate]);
  const goToHome = useCallback(() => navigate("/"), [navigate]);

  // Toggle between login and sign-up views
  const toggleView = useCallback(
    () => setIsLoginView((isLoginView) => !isLoginView),
    []
  );

  // Toggle navigation links visibility
  const toggleNav = useCallback(() => {
    setIsNavOpen((isNavOpen) => !isNavOpen);
  }, []);

  const onItemClick = useCallback(
    (item) => {
      setIsNavOpen(false);

      if (item === "our team") openOurTeam();
      else if (item === "pricing") openPricing();
      else if (item === "contact us") openContactUs();
    },
    [openOurTeam, openPricing, openContactUs]
  );

  return (
    <div className="PublicNav">
      {/* Company logo and name, navigates to home page on click */}
      <div className="public-nav-company-logo" onClick={goToHome}>
        <img src="/logo.png" alt="tastelens" />
        <h1>tastelens</h1>
      </div>

      {/* Hamburger icon for toggling navigation links */}
      <div className="hamburger-icon" onClick={toggleNav}>
        <HamburgerIcon />
      </div>

      {/* Navigation links */}
      <div className="public-nav-links">
        <button className="public-nav-link" onClick={openOurTeam}>
          our team
        </button>
        <button className="public-nav-link" onClick={openPricing}>
          pricing
        </button>
        <button className="public-nav-link" onClick={openContactUs}>
          contact us
        </button>
        <button className="public-nav-get-started" onClick={openGetStarted}>
          get started
        </button>
      </div>

      {/* Modals for navigation links */}
      <MobileNavModal
        isOpen={isNavOpen}
        onRequestClose={toggleNav}
        coreItems={["our team", "pricing", "contact us"]}
        onItemClick={onItemClick}
        fontColor="#FAC05E"
      />

      {isGetStartedOpen && isLoginView && (
        <LoginModal
          className="get-started-modal"
          isOpen={isGetStartedOpen}
          onRequestClose={closeGetStarted}
          toggleView={toggleView}
          width="28%"
        />
      )}

      {isGetStartedOpen && !isLoginView && (
        <SignUpModal
          className="get-started-modal"
          isOpen={isGetStartedOpen}
          onRequestClose={closeGetStarted}
          toggleView={toggleView}
          width="28%"
        />
      )}
    </div>
  );
};

export default PublicNav;
